<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>Delete Account Requested Successfully</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>Delete Account Requested Successfully</h1>
        <div class="glass-box">
        <h2 style="font-size: 25px;
        color: #c4c4c4;
        font-weight: 400;margin: 0;">OTP has been sent to the mail</h2>
        <div class="error-message" style="color: #fff;
        font-size: 12px;
        font-weight: 300;
        padding-bottom: 2em;">
          Please check your mail for further steps.Thanks for being a valuable
          user!
        </div>
        <div>
          <a
            href="login"
            class="btn  back-btn">Take Me Home</a>
          <a href="login" class="btn btn btn-lg" style="color: #fff;
          font-size: 12px;">Contact Support</a>
        </div>
      </div>
      </div>
    </div>
  </body>
</html>
